import { createContext } from 'react';

const notificationsContext = createContext({});

export default notificationsContext;
